import React, { useCallback, memo } from "react";

import { useNavigate } from "react-router-dom";

import Line from "@/assets/images/Lines.svg";

import { LoginForm } from "@/features/auth/components/LoginForm";
import { LoginSidebar } from "@/features/auth/components/LoginSidebar";
import { NavigationLinks } from "@/features/auth/components/NavigationLinks";
import { useQRLogin } from "@/features/auth/hooks";

const LoginScreen: React.FC = () => {
  const navigate = useNavigate();

  const { qrValue, countDown, isLoading, error, handleRefreshQR } =
    useQRLogin();

  const handleRegister = useCallback(() => {
    navigate("/");
  }, [navigate]);
  return (
    <div className="w-full h-auto md:h-[100vh] relative bg-primary-100/10">
      <div className="flex flex-col-reverse md:grid grid-cols-12 h-auto md:h-[100vh]">
        <LoginSidebar />

        <div className="col-span-9 md:flex flex-col justify-center items-center relative p-4 md:p-0">
          <img
            className="absolute top-0 left-0 w-full h-full object-cover -z-[1]"
            src={Line}
            alt="Background pattern"
            loading="lazy"
          />

          <NavigationLinks />

          <LoginForm
            qrValue={qrValue}
            countDown={countDown}
            isLoading={isLoading}
            error={error}
            onRefreshQR={handleRefreshQR}
            onRegister={handleRegister}
          />
        </div>
      </div>
    </div>
  );
};

export default memo(LoginScreen);
